import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserNetworkType } from 'user/model/user-network.type';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface DisconnectFromUserNetworkParams {
	readonly networkType: UserNetworkType;
}

@Injectable({ providedIn: 'root' })
export class DisconnectFromUserNetworkApiMutation extends ApiMutation<
	void,
	DisconnectFromUserNetworkParams
> {
	client = 'iam';
	document = gql`
		mutation DisconnectFromUserNetwork($networkType: UserNetworkType!) {
			disconnectFromUserNetwork(networkType: $networkType)
		}
	`;
	method = 'disconnectFromUserNetwork';
}
